/** @format */
import { numberStateIdMapI18n, numberStateIdMapInt } from '../views/lib/search/MsisdnStateHelper';

const numberState = {
    FREE: numberStateIdMapInt.FREE,
    USED: numberStateIdMapInt.USED,
    PLANNED: numberStateIdMapInt.PLANNED,
    LOCK: numberStateIdMapInt.LOCK,
    ARCHIVE: numberStateIdMapInt.ARCHIVE,
    E14_SEND: numberStateIdMapInt.E14_SEND,
    E14_RETRIEVED: numberStateIdMapInt.E14_RETRIEVED,
    CHANGE_IN_PROGRESS: 100,
};

export const msisdnStatus = (status: number, isM = false): string => {
    if (status >= numberState.CHANGE_IN_PROGRESS) {
        return 'pools:state.change_in_progress';
    }
    switch (status) {
        case numberState.FREE:
            if (isM) {
                return numberStateIdMapI18n.FREE_M;
            }
            return numberStateIdMapI18n.FREE;
        case numberState.USED:
            if (isM) {
                return numberStateIdMapI18n.USED_M;
            }
            return numberStateIdMapI18n.USED;
        case numberState.PLANNED:
            return numberStateIdMapI18n.PLANNED;
        case numberState.LOCK:
            return numberStateIdMapI18n.LOCK;
        case numberState.ARCHIVE:
            return numberStateIdMapI18n.ARCHIVE;
        case numberState.E14_SEND:
            return numberStateIdMapI18n.E14_SEND;
        case numberState.E14_RETRIEVED:
            return numberStateIdMapI18n.E14_RETRIEVED;
        default:
            return 'pools:state.not_defined';
    }
};
